<!-- blank-page.component.html -->
<div class="blank-container">
    <div class="content-wrapper">
        <div class="icon-container">
            <img style="height: 50px;" src="./assets/Allevents_logo.png" alt="AiEventZo Logo" class="logo-image">
        </div>

        <h1 class="title">Welcome to AiEventZo</h1>

        <p class="description">
            Your premier destination for discovering and managing events.
            Find the perfect event, connect with organizers, and create memorable experiences.
        </p>

        <div class="features">
            <div class="feature-item">
                <span class="feature-icon">🎉</span>
                <span>Browse Events</span>
            </div>
            <div class="feature-item">
                <span class="feature-icon">📅</span>
                <span>Manage Bookings</span>
            </div>
            <div class="feature-item">
                <span class="feature-icon">🎯</span>
                <span>Create Events</span>
            </div>
        </div>

        <button class="cta-button" (click)="navigateToHome()">
            Explore Events
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
        </button>

        <a [href]="websiteUrl" class="link" target="_blank">Visit aieventzo.com</a>
    </div>
</div>